import { NavBarSearch, NavPortal } from "components";
import { RecallsDashboardTable, RecallsFilters, RecallsLastExport } from "modules/RecallsDashboard/components";
import { useRecallsDashboardFilterHandlers, useRecallsDashboardFilters } from "modules/RecallsDashboard/hooks";

const RecallsDashboard = () => {
  const {
    data: { term }
  } = useRecallsDashboardFilters();
  const { handleSearchTermChange } = useRecallsDashboardFilterHandlers();

  return (
    <>
      <NavPortal>
        <RecallsLastExport />
        <NavBarSearch handleSearchChange={handleSearchTermChange} value={term} />
      </NavPortal>
      <RecallsFilters />
      <RecallsDashboardTable />
    </>
  );
};

export default RecallsDashboard;
